// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');
require('@js/hero-primary');
require('@js/sliders');
require('@js/select');
require('@js/header');
require('@js/team-block');
require('@js/ajax-blog');
